
export let objectAssignWithoutOverride = (target, ...sourceList) => {
    for (let source of sourceList) {
      if (!source) continue;
      for(let key of Object.keys(source)) {//this doesnt iterate over class like source properties
        if (!(key in target)) {//checks own and inherited keys, works fine also for class prototypes and instances
          const desc = Object.getOwnPropertyDescriptor(source, key);
          if (desc.enumerable) Object.defineProperty(target, key, desc);
        }
      }
    }
  };
  
  export let objectAssignWithOverride = (target, ...sourceList) => {
    for (let source of sourceList) {
      if (!source) continue;
      for(let key of Object.keys(source)) {//this doesnt iterate over class like source properties
        const desc = Object.getOwnPropertyDescriptor(source, key);
        if (desc.enumerable) Object.defineProperty(target, key, desc);
      }
    }
  };
  
  
  
  export let checkInstanceModifier = (target, ...sourceList) => {
    for (let source of sourceList) {
      if (!source) continue;
      for(let key of Object.keys(source)) {//this doesnt iterate over class like source properties
        const desc = Object.getOwnPropertyDescriptor(source, key);
        if (desc.enumerable) Object.defineProperty(target, key, desc);
      }
    }
  };



//   // Base classes
// class IndexedDBMixin {
//   constructor(dbName, version) {
//       this.dbName = dbName;
//       this.version = version;
//       this.dbPromise = this.openConnection();
//   }

//   openConnection() {
//       return new Promise((resolve, reject) => {
//           const request = indexedDB.open(this.dbName, this.version);

//           request.onupgradeneeded = (event) => {
//               const db = event.target.result;
//               if (!db.objectStoreNames.contains('storeName')) {
//                   db.createObjectStore('storeName', { keyPath: 'id' });
//               }
//           };

//           request.onsuccess = (event) => resolve(event.target.result);
//           request.onerror = (event) => reject(event.target.error);
//       });
//   }

//   async getDB() {
//       return await this.dbPromise;
//   }
  
//   async addRecord(storeName, record) {
//       const db = await this.getDB();
//       return new Promise((resolve, reject) => {
//           const transaction = db.transaction(storeName, 'readwrite');
//           const store = transaction.objectStore(storeName);
//           const request = store.add(record);

//           request.onsuccess = () => resolve(request.result);
//           request.onerror = () => reject(request.error);
//       });
//   }

//   async getRecord(storeName, key) {
//       const db = await this.getDB();
//       return new Promise((resolve, reject) => {
//           const transaction = db.transaction(storeName, 'readonly');
//           const store = transaction.objectStore(storeName);
//           const request = store.get(key);

//           request.onsuccess = () => resolve(request.result);
//           request.onerror = () => reject(request.error);
//       });
//   }
// }

// class LoggingMixin {
//   log(message) {
//       console.log(message);
//   }
  
//   error(message) {
//       console.error(message);
//   }
// }

// // Mixin function
// function applyMixins(targetClass, baseClasses) {
//   baseClasses.forEach(baseClass => {
//       Object.getOwnPropertyDescriptors(baseClass.prototype).forEach(descriptor => {
//           Object.defineProperty(targetClass.prototype, descriptor[0], descriptor[1]);
//       });
//   });
// }

// // Combined class
// class EnhancedIndexedDB extends IndexedDBMixin {
//   constructor(dbName, version) {
//       super(dbName, version);
//   }
// }

// // Apply mixins
// applyMixins(EnhancedIndexedDB, [LoggingMixin]);

// // Usage example
// const dbFacade = new EnhancedIndexedDB('myDatabase', 1);

// dbFacade.addRecord('storeName', { id: 1, name: 'Sample' })
//   .then((id) => {
//       dbFacade.log('Record added with id: ' + id);
//   })
//   .catch((error) => {
//       dbFacade.error('Error adding record: ' + error);
//   });

// dbFacade.getRecord('storeName', 1)
//   .then((record) => {
//       dbFacade.log('Record retrieved: ' + JSON.stringify(record));
//   })
//   .catch((error) => {
//       dbFacade.error('Error retrieving record: ' + error);
//   });
